import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, CardBlock, Row, Col } from 'reactstrap';
import { Table, Button, Modal } from 'antd';
import Pagination from 'rc-pagination';
import { toastr } from 'react-redux-toastr'
import Select from 'react-select';
import { SERVER_URL } from './../../../../config/host';
import * as actionScoreExchange from './../../../../actions/scoreExchange';
import * as actionUser from './../../../../actions/user';

@connect(
  state => ({
    scoreExchangeState: state.get('ScoreExchange'),
    userState: state.get('User')
  }),
  dispatch => ({
    scoreExchangeAction: bindActionCreators(actionScoreExchange, dispatch),
    userAction: bindActionCreators(actionUser, dispatch)
  })
)

export default class ScoreExchange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      scoreList: {},
      status: '',
      loading: false
    };
  }
  componentWillMount() {
    const { scoreExchangeAction, userAction } = this.props;
    userAction.fetchGetUserName();
    scoreExchangeAction.fetchGetScoreExchange({ page: this.state.page, limit: this.state.limit })
      .then(() => { this.handleData(); });
  }
  // props 改变时调用
  componentWillReceiveProps(nextProps) {
    const { userState, scoreExchangeState } = nextProps;
    const { data } = (userState && userState.toJS().data) || {};
    // 当前者不为空执行后者，前者为空执行||
    const exportData = (scoreExchangeState && scoreExchangeState.toJS().export.data) || {};
    this.setState({ userName: data, exportData: exportData });
  }
  // 设置状态
  setUser = (value) => {
    this.setState({
      user: (value && value.id) || ''
    })
  };
  setStatus = (value) => {
    this.setState({
      status: (value && value.id) || ''
    })
  }
  // 弹窗控制
  handleOk = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  handleCancel = () => {
    this.setState({
      loaded: !this.state.loaded
    });
  }
  export = () => {
    const { scoreExchangeAction, scoreExchangeState } = this.props;
    this.setState({ loading: true });
    const { user, status } = this.state;
    scoreExchangeAction.fetchGetScoreExchangeExport({ id: user, status: status })
      .then(() => {
        const loaded = scoreExchangeState && scoreExchangeState.get('loaded');
        this.setState({ loaded: loaded, loading: false });
      })
  }
  handleData = () => {
    const { scoreExchangeState } = this.props;
    const { data } = scoreExchangeState.toJS().data;
    this.setState({ scoreList: data });
  };
  confirm = (value) => {
    const { scoreExchangeAction } = this.props;
    scoreExchangeAction.fetchconfirm(value._id)
      .then(() => {
        const { scoreExchangeState } = this.props;
        const data = scoreExchangeState.get('data');
        if (data.get('success')) {
          toastr.success(data.get('message'));
          this.pageChange(this.state.page);
        } else {
          toastr.error('错误信息', data.get('message'));
        }
      })
      .catch(() => { toastr.error('错误信息', '发货失败！请稍候再试') })
  }
  search = () => {
    const { page, limit, user, status } = this.state;
    const { scoreExchangeAction } = this.props;
    scoreExchangeAction.fetchGetScoreExchange({ page: page, limit: limit, userId: user, status: status })
      .then(() => { this.handleData(); })
  }
  pageChange = (page) => {
    this.setState({ page: page })
    const { limit, user, status } = this.state;
    const { scoreExchangeAction } = this.props;
    scoreExchangeAction.fetchGetScoreExchange({ page: page, limit: limit, userId: user, status: status })
      .then(() => { this.handleData(); })
  }

  render() {
    const { scoreList, userName, user, status, exportData } = this.state;
    const columns = [
      { title: '用户', dataIndex: 'user.username', render: (text, record) => <div>{record.user.username}</div> },
      { title: '电话', dataIndex: 'user.phone', render: (text, record) => <div>{record.user.phone}</div> },
      { title: '经销商', dataIndex: 'user.name', render: (text, record) => <div>{record.user.name}</div> },
      { title: '兑换时间', dataIndex: 'date' },
      { title: '产品', dataIndex: 'scoregoods.describe', render: (text, record) => <div>{record.scoregoods.describe}</div> },
      { title: '状态', dataIndex: 'status' },
      { title: '操作', dataIndex: '_id', render: (text, record) => <Button type="primary" onClick={() => this.confirm(record)}>确认发货</Button> }
    ]
    const statusList = [
      { id: '待处理', value: '待处理' },
      { id: '待发货', value: '待发货' }
    ]
    return (
      <Card>
        <CardBlock>
          <Row className="form-group">
            <Col md="12">
              <div className="input-group">
                <Col md="4">
                  <Select
                    placeholder="用户名"
                    labelKey="name"
                    valueKey="id"
                    value={user || ''}
                    options={userName}
                    onChange={e => this.setUser(e)}
                  />
                </Col>
                <Col md="4">
                  <Select
                    placeholder="状态"
                    labelKey="value"
                    valueKey="id"
                    value={status || ''}
                    options={statusList}
                    onChange={e => this.setStatus(e)}
                  />
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.search} className="btn btn-primary btn-pointer"><i className="fa fa-search" /> </button>
                  </span>
                </Col>
                <Col md="1">
                  <span className="input-group-btn">
                    <button size="large" onClick={this.export} className="btn btn-primary btn-pointer">{this.state.visible ? '导出中' : '导出'}</button>
                  </span>
                  <Modal
                    visible={this.state.loaded}
                    title="提示"
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                  >
                    <p>导出成功,请长按地址在浏览器打开</p>
                    <p>{SERVER_URL}/{exportData && exportData.data && exportData.data.downloadUrl}</p>
                  </Modal>
                </Col>
              </div>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md="12">
              <Table
                loading={this.state.loading}
                pagination={false}
                rowKey="id"
                bordered
                columns={columns}
                dataSource={scoreList.docs}
                showHeader="false"
                size="middle"
              />
              <div className="card-block">
                <Pagination
                  showLessItems
                  current={this.state.page}
                  pageSize={this.state.limit}
                  onChange={this.pageChange}
                  showTotal={(total, range) => `${range[0]} - ${range[1]} 共 ${total} 条`}
                  total={scoreList.total}
                />
              </div>
            </Col>
          </Row>
        </CardBlock>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/App/Score/ScoreExchange/index.js